export { FiveTabWidget } from './FiveTabWidget';
